import SelectSortType from './select-sort-type'

export default SelectSortType
